export default "__VITE_ASSET__AqvSlm4___"